export const ChessTypes = {
  NONE: '无棋',
  NORMAL: '有棋',
};



// WEBPACK FOOTER //
// ./src/constants.js